/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mode_Three_LivesInputs */

const bn_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 জীবন`)
};

const de_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Leben`)
};

const el_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Ζωές`)
};

const en_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Lives`)
};

const es_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 vidas`)
};

const fr_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Vies`)
};

const hi_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 जीवन`)
};

const hu_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Élet`)
};

const id_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Kehidupan`)
};

const it_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 vite`)
};

const ja_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 ライブ`)
};

const ko_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3개의 생명`)
};

const nl_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 levens`)
};

const pl_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 życia`)
};

const pt_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 vidas`)
};

const ru_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 жизни`)
};

const sv_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 liv`)
};

const tr_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Hayat`)
};

const uk_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 життя`)
};

const vi_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 cuộc đời`)
};

const zh_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 条生命`)
};

const zh_hant_mode_three_lives = /** @type {(inputs: Mode_Three_LivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 條生命`)
};

/**
* | output |
* | --- |
* | "3 Lives" |
*
* @param {Mode_Three_LivesInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const mode_three_lives = /** @type {((inputs?: Mode_Three_LivesInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mode_Three_LivesInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_mode_three_lives(inputs)
	if (locale === "de") return de_mode_three_lives(inputs)
	if (locale === "el") return el_mode_three_lives(inputs)
	if (locale === "en") return en_mode_three_lives(inputs)
	if (locale === "es") return es_mode_three_lives(inputs)
	if (locale === "fr") return fr_mode_three_lives(inputs)
	if (locale === "hi") return hi_mode_three_lives(inputs)
	if (locale === "hu") return hu_mode_three_lives(inputs)
	if (locale === "id") return id_mode_three_lives(inputs)
	if (locale === "it") return it_mode_three_lives(inputs)
	if (locale === "ja") return ja_mode_three_lives(inputs)
	if (locale === "ko") return ko_mode_three_lives(inputs)
	if (locale === "nl") return nl_mode_three_lives(inputs)
	if (locale === "pl") return pl_mode_three_lives(inputs)
	if (locale === "pt") return pt_mode_three_lives(inputs)
	if (locale === "ru") return ru_mode_three_lives(inputs)
	if (locale === "sv") return sv_mode_three_lives(inputs)
	if (locale === "tr") return tr_mode_three_lives(inputs)
	if (locale === "uk") return uk_mode_three_lives(inputs)
	if (locale === "vi") return vi_mode_three_lives(inputs)
	if (locale === "zh") return zh_mode_three_lives(inputs)
	return zh_hant_mode_three_lives(inputs)
});